module.exports = __webpack_public_path__ + "img/gartek-portfolio-institutional.9479d4f5.jpeg";